'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".PudoRaw-module_wrapper__IFUiM{display:flex;flex-direction:column;justify-content:center;padding:1.5rem}.PudoRaw-module_pudoElmWrap__u9Cud{align-items:center;display:flex;flex-direction:column;justify-content:center;width:100%}.PudoRaw-module_pudoGroup__vaFe8{display:flex;flex-direction:column;gap:8px;justify-content:stretch;justify-self:center;max-width:520px;width:100%}";
var styles = {"wrapper":"PudoRaw-module_wrapper__IFUiM","pudoElmWrap":"PudoRaw-module_pudoElmWrap__u9Cud","pudoGroup":"PudoRaw-module_pudoGroup__vaFe8"};
styleInject["default"](css_248z, 'cf3edfe6-066e-4ecd-a1ce-05a924f872b3');

exports["default"] = styles;
